module.exports = __webpack_public_path__ + "static/media/customer-hiw-2.4b8d408c.png";